// Canonical locale list. Lives here, in CommonJS, so both the frontend's
// vue-i18n catalogs and the plain-node CI check (scripts/check-i18n.js) read
// one list rather than two that can drift. Presentation details that only the
// frontend cares about — the Vuetify locale-pack key, the Intl tag, rtl —
// stay in frontend/src/i18n/locales/index.js, which re-exports these.
//
// The backend is deliberately not a consumer: it emits error codes and lets
// clients translate them, and its emails are English by decision.
const DEFAULT_LOCALE = 'en';

const SUPPORTED_LOCALE_CODES = ['en', 'zh-CN'];

const isSupportedLocale = (code) => Boolean(code) && SUPPORTED_LOCALE_CODES.includes(code);

module.exports = {
  DEFAULT_LOCALE,
  SUPPORTED_LOCALE_CODES,
  isSupportedLocale,
};
